import WINDOW from "../../../../utils/window";
import getAxisValue from "./get-axis-value";
import getPointerMiddleBoth from "./get-pointer-middle-both";
import getPointerMiddleX from "./get-pointer-middle-x";
import getPointerMiddleY from "./get-pointer-middle-y";

/**
 *
 * @param {MainClassProps} _main
 * @param {TriggerProps} trigger
 * @returns
 */
const getPointerMiddle = (_main, trigger) => {
  const axis = getAxisValue(trigger);
  const pointer = /** @type {Map<"x" | "y", any>} */ (WINDOW.get("pointer"));

  switch (axis) {
    case "x":
      return getPointerMiddleX(pointer);

    case "y":
      return getPointerMiddleY(pointer);

    default:
      return getPointerMiddleBoth(pointer);
  }
};

export default getPointerMiddle;
